<template>
    <div>
        <app-sub-title text="Salida de Visitantes" />
        <b-tabs content-class="mt-3">
            <b-tab title="Visitantes" active>
                <b-row class="my-3">
                    <b-col>
                        <b-form-input
                            @input="searchEntry"
                            placeholder="Buscar"
                        ></b-form-input>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" md="6">
                        <div
                            class="d-flex justify-content-center"
                            v-if="!!visitorTypes.length"
                        >
                            <app-quick-filters
                                :filters="visitorTypes"
                                @filter="filterByType"
                            ></app-quick-filters>
                            <!-- <b-row align-v="end" align-h="center">
                                <b-col cols="6" md="3"
                                    ><b-btn
                                        variant="link"
                                        @click="clearFilters"
                                        size="sm"
                                        >Todos</b-btn
                                    ></b-col
                                >
                                <b-col
                                    v-for="type in visitorTypes"
                                    :key="type.id"
                                    cols="6"
                                    md="3"
                                >
                                    <b-btn
                                        size="sm"
                                        variant="link"
                                        @click="filterByType(type.id)"
                                        >{{ type.name }}</b-btn
                                    ></b-col
                                >
                            </b-row> -->
                        </div>
                        <app-person-entry-list
                            @passenger-out="onPassengerOut"
                            ref="person-entry-list"
                        />
                    </b-col>
                    <b-col cols="12" md="6">
                        <div
                            class="d-flex justify-content-center"
                            v-if="!!visitorTypes.length"
                        >
                            <app-quick-filters
                                :filters="vehicleEntryTypes"
                                @filter="filterVehiclesByType"
                            ></app-quick-filters>
                            <!-- <b-button-group>
                                <b-btn
                                    variant="link"
                                    @click="clearVehicleFilters"
                                    >Todos</b-btn
                                >
                                <b-btn
                                    v-for="type in vehicleEntryTypes"
                                    :key="type.id"
                                    variant="link"
                                    @click="filterVehiclesByType(type.id)"
                                    >{{ type.name }}</b-btn
                                >
                            </b-button-group> -->
                        </div>
                        <app-vehicle-entry-list
                            @passengers-out="onPassengersOut"
                            ref="vehicle-entry-list"
                        />
                    </b-col>
                </b-row>
            </b-tab>
            <b-tab title="Vehículos de carga">
                <app-cargo-vehicle-departures-page />
            </b-tab>
        </b-tabs>
    </div>
</template>
<script>
import appPersonEntryList from './Person/PersonEntryList'
import appVehicleEntryList from './Vehicle/VehicleEntryList'
import appCargoVehicleDeparturesPage from './CargoVehicle/CargoVehicleDeparturesPage'
import { mapGetters, mapMutations } from 'vuex'
import * as mutations from '@store/commitTypes'
import appQuickFilters from './Common/QuickFilters'
export default {
    components: {
        appPersonEntryList,
        appCargoVehicleDeparturesPage,
        appVehicleEntryList,
        appQuickFilters,
    },
    data: () => ({
        personEntries: [],
        vehicleEntries: [],
        visitorTypes: [],
        vehicleEntryTypes: [],
    }),
    computed: {},
    methods: {
        async loadVisitorTypes() {
            const { data } = await this.$repo.get('visitor-types')
            this.visitorTypes = [
                { id: -1, name: 'Todos' },
                ...data.filter(item => commonVisitorTypes.includes(item.slug)),
            ]
        },
        filterByType(type) {
            if (type.id === -1) return this.clearFilters()

            this.$refs['person-entry-list'].loadPersonEntries({
                visitorTypeId: type.id,
            })
        },
        filterVehiclesByType(type) {
            if (type.id === -1) return this.clearVehicleFilters()

            this.$refs['vehicle-entry-list'].loadVehicleEntries({
                vehicleEntryTypeId: type,
            })
        },
        clearFilters() {
            this.$refs['person-entry-list'].clearFilters()
        },
        clearVehicleFilters() {
            this.$refs['vehicle-entry-list'].clearFilters()
        },
        searchEntry(term) {
            if (term.length === 0) {
                this.$refs['vehicle-entry-list'].loadVehicleEntries({
                    term: null,
                })
                this.$refs['person-entry-list'].loadPersonEntries({
                    term: null,
                })
            }
            if (term.length < 3) return

            if (term.toLowerCase() !== term.toUpperCase()) {
                this.$refs['vehicle-entry-list'].loadVehicleEntries({ term })
            }
            this.$refs['person-entry-list'].loadPersonEntries({ term })
        },
        async loadVehicleEntryTypes() {
            const { data } = await repo.get('vigilance/vehicle-entry-types')
            this.vehicleEntryTypes = [{ id: -1, name: 'Todos' }, ...data]
        },
        // Cuando sale un vehiculo y con el salen pasajeros (vehicle departure)
        onPassengersOut() {
            this.$refs['person-entry-list'].loadPersonEntries()
        },
        // Cuando una persona sale a pie y era un pasajero (person departure)
        onPassengerOut() {
            this.$refs['vehicle-entry-list'].loadVehicleEntries()
        },
    },
    mounted() {
        this.loadVisitorTypes()
        this.loadVehicleEntryTypes()
    },
}

const commonVisitorTypes = [
    'particular',
    'domicilio',
    'empleada-domestica',
    'contratista',
    'empleado',
    'funcionario-shatter',
]
</script>
